<template>
    <div>
        <table class="kgr-table kgr-table--striped kgr-table--block kgr-row kgr-row--extraBigMargin">
            <thead>
                <tr class="kgr-table__row">
                    <th
                        class="kgr-table__cell kgr-table__cell--headline"
                        style="width: 110px"
                    >
                        {{ $t('Vorschau') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Name') }}
                    </th>
                    <th
                        class="kgr-table__cell kgr-table__cell--headline"
                        style="width: 110px"
                    >
                        {{ $t('Größe') }}
                    </th>
                    <th
                        class="kgr-table__cell kgr-table__cell--headline"
                        style="width: 110px"
                    >
                        {{ $t('Download') }}
                    </th>
                    <th
                        v-if="isEditable"
                        class="kgr-table__cell kgr-table__cell--headline"
                        style="width: 110px"
                    >
                        {{ $t('Löschen') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="file in files"
                    :key="file.hash"
                    class="kgr-table__row"
                >
                    <td>
                        <img
                            v-if="file.isImage"
                            :src="file.downloadUrl"
                            alt="preview"
                            width="100px"
                            height="100px"
                        />
                    </td>
                    <td>{{ file.title }}</td>
                    <td>{{ formattedSize(file) }} KB</td>
                    <td>
                        <a
                            class="kgr-button"
                            :href="file.downloadUrl"
                        >
                            {{ $t('Download') }}
                        </a>
                    </td>
                    <td v-if="isEditable">
                        <a
                            class="kgr-button kgr-button--danger"

                            @click="(e) => {e.preventDefault(); deleteFile(file)}"
                        >
                            {{ $t('Löschen') }}
                        </a>
                    </td>
                </tr>
                <tr v-if="files.length === 0">
                    <td
                        :colspan="isEditable ? 5 : 4"
                        class="kgr-headline--h3 kgr-headline--centered"
                    >
                        {{ $t('Keine Dateien hochgeladen') }}
                    </td>
                </tr>
                <tr
                    v-if="isEditable"
                    class="kgr-row--bigMargin"
                >
                    <td
                        colspan="5"
                        style="padding: 20px;"
                    >
                        <div>
                            <div class="kgr-row">
                                <h1 class="kgr-headline--h1">
                                    {{ $t('Dateien hinzufügen') }}
                                </h1>
                            </div>
                            <kgr-form-row
                                :label="$t('Datei auswählen')"
                                :error="error"
                                field-name="file"
                            >
                                <form style="display: inline-block;">
                                    <input
                                        type="file"
                                        @change="upload.file = $event.target.files[0]"
                                    />
                                </form>
                            </kgr-form-row>
                            <kgr-form-row
                                :label="$t('Dateiname')"
                                :error="error"
                                field-name="title"
                            >
                                <input
                                    v-model.trim="upload.title"
                                    type="text"
                                    class="kgr-input"
                                />
                            </kgr-form-row>
                            <kgr-button
                                :value="$t('Hochladen')"
                                :pending="pendingUpload"
                                type="blue"
                                style="margin-top: 20px;"
                                @click="uploadFile"
                            />
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <kgr-confirm-dialog :headline="$t('delete')" ref="confirmDelete">
            <p v-t="$t('Soll diese Datei wirklich gelöscht werden? Nach dem Löschen ist diese nicht wiederherzustellen.')"></p>
        </kgr-confirm-dialog>
    </div>
</template>

<script>
import ApplicationMember from '../../js/dto/ApplicationMember';
import ApplicationMemberFileRepository from '../../js/repository/ApplicationMemberFileRepository';
import ConfirmDialog from '../../components/common/modal/ConfirmDialog.vue';
import Error from '../../js/model/Error';
import FormRow from '../../components/common/form/FormRow.vue';
import KgrButton from '../../components/common/form/button/KgrButton.vue';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-form-row': FormRow,
        'kgr-confirm-dialog': ConfirmDialog,
    },
    props: {
        isEditable: {
            type: Boolean,
            default: true,
            required: false,
        },
        memberFiles: {
            type: Array,
            required: true,
        },
        applicationMember: {
            type: ApplicationMember,
            required: true,
        },
    },
    data() {
        return {
            upload: {
                file: null,
                title: '',
            },
            pendingUpload: false,
            error: new Error(),
            files: [],
        };
    },
    mounted() {
        this.files = this.memberFiles;
    },
    methods: {
        uploadFile() {
            ApplicationMemberFileRepository.upload(this.upload.file, this.upload.title, this.applicationMember)
                .then((file) => {
                    this.files.push(file)
                    this.upload.file = null;
                    this.upload.title = '';
                    this.$emit('update', this.files)
                })
                .catch((error) => {
                    this.error = error;
                });
        },
        async deleteFile(file) {
            const confirmed = await this.$refs.confirmDelete.open();
            if(!confirmed) {
                return;
            }
            ApplicationMemberFileRepository.remove(file, this.applicationMember)
                .then(() => {
                    this.files = this.files.filter(f => f.hash !== file.hash);
                    this.$emit('update', this.files)
                })
                .catch((error) => {
                    this.error = error;
                });
        },
        formattedSize(file) {
            if (file.size === null) {
                return '-';
            }
            return new Intl.NumberFormat('de-DE').format(file.size/1024);
        },
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">

</style>
